import {
  PASSWORD_RESET_REQUEST,
  PASSWORD_RESET_SUCCESS,
  PASSWORD_RESET_FAILURE,
  PASSWORD_RESET_CONFIRM_REQUEST,
  PASSWORD_RESET_CONFIRM_SUCCESS,
  PASSWORD_RESET_CONFIRM_FAILURE,
} from '../actions/password_reset'

const initialState = {
  isRequestingCode: false,
  isConfirming: false,
}

export function passwordReset(state = initialState, action) {
  switch (action.type) {
    case PASSWORD_RESET_REQUEST:
      return { ...state, isRequestingCode: true }
    case PASSWORD_RESET_SUCCESS:
    case PASSWORD_RESET_FAILURE:
      return { ...state, isRequestingCode: false }
    case PASSWORD_RESET_CONFIRM_REQUEST:
      return { ...state, isConfirming: true }
    case PASSWORD_RESET_CONFIRM_SUCCESS:
    case PASSWORD_RESET_CONFIRM_FAILURE:
      return { ...state, isConfirming: false }
    default:
      return state
  }
}
